import React from 'react';

const Submit = (props) => {

    const noMargin = props.no_margin ? 'no-margin' : ''

    const secondary = props.secondary ? 'secondary' : ''

    const disabled = props.disabled ? true : false
    const fullWidth = props.fullWidth ? 'button--fullWidth' : ''

    return (
        <button className={`${noMargin} ${secondary} ${fullWidth}`} disabled={disabled} type="submit">{props.value}</button>
    )
}

export default Submit;